import React, { ReactNode } from 'react';
import { UserApplicationRole } from '../../constants';
import { useRoleGuardContext } from '../../providers/RoleGuardContext';

export interface RoleGuardProps {
  requiredRoles: UserApplicationRole[];
  children?: ReactNode; // ✅ Add children here
}

export const RoleGuard: React.FC<RoleGuardProps> = ({
  requiredRoles,
  children,
}) => {
  const roleGuardContext = useRoleGuardContext();

  return roleGuardContext.userHasRoles(requiredRoles) ? <>{children}</> : null;
};
